import { getToken } from 'src/redux/selectors';

export function addSites(values, activateDisplayId) {
  if (activateDisplayId) {
    values.activateDisplayId = true;
  }
  return dispatch =>
    new Promise((resolve, reject) => {
      return fetch(
        process.env.REACT_APP_GLOBAL_SERVER +
          'sproutmanagement/api/sites/addsites',
        {
          method: 'POST',
          mode: 'cors',
          headers: {
            Authorization: 'Bearer ' + getToken(),
            'Content-Type': 'application/json; charset=utf-8'
          },
          body: JSON.stringify(values)
        }
      ).then(async res => {
        if (!res.ok) {
          return reject({ message: 'Failed to add sites' });
        }
        return resolve(await res.text());
      });
    }).catch(err => {
      throw err.message;
    });
}

export function deleteSites(id) {
  return dispatch =>
    new Promise((resolve, reject) => {
      return fetch(
        process.env.REACT_APP_GLOBAL_SERVER +
          'sproutmanagement/api/sites/deletesites',
        {
          method: 'POST',
          mode: 'cors',
          headers: {
            Authorization: 'Bearer ' + getToken(),
            'Content-Type': 'application/json; charset=utf-8'
          },
          body: JSON.stringify({ id: id })
        }
      )
        .then(res => {
          if (!res.ok) {
            return reject({ message: 'Failed to delete sites' });
          }
          res.text();
        })
        .catch(async error => {
          return reject(error);
        })
        .then(async response => {
          try {
            return resolve({ message: response });
          } catch (e) {
            return reject({ message: response });
          }
        });
    }).catch(err => {
      throw err.message;
    });
}

export function findAllSites(access) {
  let url;
  if (access) {
    url =
      process.env.REACT_APP_GLOBAL_SERVER +
      'sproutmanagement/api/sites/findallsites?access=' +
      access;
  } else {
    url =
      process.env.REACT_APP_GLOBAL_SERVER +
      'sproutmanagement/api/sites/findallsites';
  }
  return dispatch =>
    new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_GLOBAL_SERVER +
          'sproutmanagement/api/sites/findallsites',
        {
          method: 'GET',
          mode: 'cors',
          headers: {
            Authorization: 'Bearer ' + getToken(),
            'Content-Type': 'application/json; charset=utf-8'
          }
        }
      ).then(async res => {
        if (!res.ok) {
          return reject({ message: await res.text() });
        }
        return resolve(
          dispatch({
            type: 'SITES_FIND_ALLSITES',
            data: await res.json()
          })
        );
      });
    }).catch(err => {
      throw err.message;
    });
}

export function findAllSitesInventory() {
  const url =
    process.env.REACT_APP_GLOBAL_SERVER_SPROUT +
    'sprout360/api/sites/findallsitesinventoryclient';

  return dispatch =>
    new Promise((resolve, reject) => {
      fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      })
        .then(async res => {
          if (!res.ok) return reject({ message: await res.text() });
          const json = await res.json();

          dispatch({ type: 'SITES_FIND_ALLSITES_INVENTORY', data: json });
          return resolve({ data: json });
        })
        .catch(err => reject({ message: err.message || 'Failed to fetch' }));
    });
}

// Remember the site the user is working on so every page with a site selector
// starts on the same one.
export function setSelectedSite(siteId) {
  return dispatch =>
    dispatch({
      type: 'SITES_SET_SELECTEDSITE',
      data: siteId
    });
}

export function setEditSites(sites) {
  return dispatch =>
    dispatch({
      type: 'SITESS_SET_EDITSITES',
      data: sites
    });
}

export function setSitesDetailsId(id) {
  return dispatch =>
    dispatch({
      type: 'SITESS_SET_SITESDETAILSID',
      data: id
    });
}
